import React, {Component, createElement} from 'react';
import {connect} from 'react-redux';
import FancyButton from '../widgets/FancyButton';
import './MessagePanel.css';

const getSecondsSinceLastMessage = props =>
	Math.floor((new Date().getTime() - props.messageTime) / 1000);

const getIsShown = (state, message, secondsSinceLastMessage) =>
	!state.userClosed &&
	message &&
	(typeof message === 'function' || message.length) &&
	secondsSinceLastMessage < 5;

class MessagePanel extends Component {
	constructor() {
		super();

		this.state = {
			userClosed: false
		};

		this.close = () => this.setState({userClosed: true});
		this.reupdateSoon = () => setTimeout(() => this.forceUpdate(), 500); // Re-render every 1second when visible
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.message !== this.props.message ||
			nextProps.messageTime !== this.props.messageTime
		) {
			this.setState({
				userClosed: false
			});
		}
	}

	render() {
		const {message, type} = this.props;
		const secondsSinceLastMessage = getSecondsSinceLastMessage(this.props);
		const isShown = getIsShown(this.state, message, secondsSinceLastMessage);

		if (isShown) this.reupdateSoon(); // Re-render every 1second when visible

		return (
			<div className={`MessagePanel ${isShown ? 'shown' : 'hidden'} ${type || ''}`}>
				<div className="MessagePanel-message">
					<span className="icon icon-info" />
					{message ? (
						typeof message === 'string' ? (
							<p>{message}</p>
						) : (
							createElement(message)
						)
					) : (
						undefined
					)}
				</div>
				<div className="MessagePanel-actions">
					<FancyButton onClick={this.close}>
						OK {secondsSinceLastMessage < 5 ? `(Closing in ${5 - secondsSinceLastMessage})` : ''}
					</FancyButton>
				</div>
			</div>
		);
	}
}

const ConnectedMessagePanel = connect(
	({ui}) => ({
		message: ui.message,
		type: ui.messageType,
		messageTime: ui.messageTime
	}),
	dispatch => ({})
)(MessagePanel);

export default ConnectedMessagePanel;



// WEBPACK FOOTER //
// ./src/chrome/MessagePanel.js